import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-retest-list',
  templateUrl: './retest-list.component.html',
  styleUrls: ['./retest-list.component.css']
})
export class RetestListComponent {

  retestList: any[] = [];
  loading: boolean = true;
  cols: any[] = [];

  constructor(private dataService: DataService,
  private router: Router,
  private messageService: MessageService){}

  ngOnInit() {
    const filters = localStorage.getItem("filters");
    //this.runList.push({runId:123, runDate:Date.now(), name: "testrun123", openSamples:true, autoApproved:false})
    //this.loading = false;
    this.loadData();

    this.cols = [
      { field: 'processedDate', header: 'Run Date' },
      { field: 'name', header: 'Run Name' },
      { field: 'openSamples', header: 'Open Samples' },
      { field: 'autoApproved', header: 'Auto Approved' }
    ];
  }

  loadData(){
    this.dataService.getPendingRetestList().then(data => {
      this.retestList = data;
      this.loading = false;
    });
  }
}
